import "./style.css";
import Button from "components/Buttons";
import ModalStore from "components/Modal/ModalStore";
import { FormProvider, useForm } from "react-hook-form";
import { useModalStore } from "stores/modal/useModalStore";
import { useHorseStore } from "stores/horse/useHorseStore";
import { getItemFromStorage, removeItemFromStorage } from "utils/localStorage";

const DeleteForm = () => {
  const close = useModalStore((s) => s.close);

  const isDeleting = useHorseStore(state => state.isDeleting);
  // Subscription kept (binding unused) to preserve re-render behavior.
  useHorseStore(state => state.horseData);
  const deleteHorses = useHorseStore(state => state.deleteHorses);

  const setIsDeleting = useHorseStore(action => action.setIsDeleting);
  const setDeleteHorses = useHorseStore(action => action.setDeleteHorses);
  const setIsDeletedSuccessfully = useHorseStore(action => action.setIsDeletedSuccessfully);

  const deleteHorse = useHorseStore(action => action.deleteHorse);

  const methods = useForm({
    defaultValues: {
      name: "",
      dob: "",
      color: "",
      photo: null,
    },
  });

  const onSubmit = async (data) => {
    console.log("onSubmit from delete", data)
    setIsDeleting(true);
    try {
     await deleteHorse({ ids: deleteHorses, refetchQueries: ["listUserHorses"] });

      const horseFromLocalStorage = getItemFromStorage("selectedHorse");
      if (deleteHorses?.includes(horseFromLocalStorage?.value)) {
        removeItemFromStorage("selectedHorse");
      }
      ModalStore.openSimpleDelete({
        title: "Deleted!",
        subtitle:
          deleteHorses.length > 1
            ? "The selected horse profiles has been erased"
            : "This horse profile has been erased",
      });

      setDeleteHorses([]);
      setIsDeletedSuccessfully((prevValue) => !prevValue);
      close();
    } catch (error) {
      ModalStore.openSimpleDelete({
        title: "Error!",
        subtitle: error.message || "Failed to delete horse. Please try again.",
      });
    } finally {
     setIsDeleting(false);
    }
  };

  const renderForm = () => {
    return (
      <div className=" flex flex-col items-center gap-[38px]">
        <div className=" flex justify-center gap-3 mt-[33px]">
          <p className="delete-form__text">
            {deleteHorses.length > 1
              ? "Are you sure you want to delete the selected profiles?"
              : "Are you sure you want to delete this profile?"}
          </p>
        </div>
        <div className="flex gap-[40px] horse-form-actions">
          <Button
            type={"submit"}
            className={"horse-add-save-btn"}
            primary
            whiteOutline
            loading={isDeleting}
          >
            Delete
          </Button>
          <Button
            type="button"
            onClick={close}
            className={"horse-add-cancel-btn"}
            primaryOutline
          >
            cancel
          </Button>
        </div>
      </div>
    );
  };

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>{renderForm()}</form>
      </FormProvider>
    </>
  );
}

export default DeleteForm;